import axios from "axios";
import config from "../config/constants";
import { toastr } from "react-redux-toastr";
import {loadProcessToken } from "../actions/index";

const BASE_URL = config.PROJECT_DASHBOARD_API_URL + "aiservice";
export const LOAD_JD = "LOAD_JD";
export const LOAD_JD_INFO = "LOAD_JD_INFO";
export const UPDATE_JD = "UPDATE_JD";
export const CREATE_JD = "CREATE_JD";
export const DELETE_JD = "DELETE_JD";
export const SETUP_DONE = "SETUP_DONE";

export const ERROR = "ERROR";

export const loadJobDefinitions = (props, scope) => {
  let token = loadProcessToken();
  console.log(props, scope);
  return (dispatch, getState) => {
    let { selected_project } = getState();
    console.log(selected_project);
    console.log("Sending Job definitions request");
    axios
      .get(`${BASE_URL}/job_definitions?projectId=${selected_project._id}`)
      .then(({ data }) => {
          console.log("received job definitions");
          dispatch({
            type: LOAD_JD,
            payload: data
          });
      })
      .catch(function(error) {
        dispatch({
          type: ERROR,
          payload: { type: "danger", message: "Invalid Credentials" }
        });
      });
  };
};



export const loadDetailedJDInfo = (props, scope) => {
  let token = loadProcessToken();
  console.log(props, scope);
  let { _id, formType } = props;
  return (dispatch, getState) => {
    axios
      .get(`${BASE_URL}/job_definitions?_id=${_id}`)
      .then(({ data }) => {
        if (data.parameters) {
          let parameters = data.parameters;
          let modifiedParameters = [];
          for (let i in parameters) {
            modifiedParameters.push({ key: i, value: parameters[i] });
          }
          data.parameters = modifiedParameters;
        }
        data["formType"]=formType;
        dispatch({
          type: LOAD_JD_INFO,
          payload: data
        });
      })
      .catch(function(error) {
        dispatch({
          type: ERROR,
          payload: { type: "danger", message: "Invalid Credentials" }
        });
      });
  };
};

export const createOrUpdateJD = (props, scope) => {
  console.log("Creating updating job definition");
  let token = loadProcessToken();
  console.log("props", props);
  let { parameters, _id } = props;
  if (parameters) {
    let modifiedParameters = {};
    for (let parameter of parameters) {
      modifiedParameters[parameter.key] = parameter.value;
    }
    props.parameters = modifiedParameters;
  }
  if (_id) {
    return (dispatch, getState) => {
      axios
        .put(`${BASE_URL}/job_definitions?_id=${_id}`, props)
        .then(({ data }) => {
          dispatch({
            type: UPDATE_JD,
            payload: data
          });

          toastr.success("Successfully updated the Job Definition");
        })
        .catch(function(error) {
          toastr.error(
            "Failed to update the job definition",
            "Please check the inputs"
          );
        });
    };
  } else {
    return (dispatch, getState) => {
      axios
        .post(`${BASE_URL}/job_definitions`, props)
        .then(({ data }) => {
          toastr.success("Successfully created the job definition.");
          dispatch({
            type: CREATE_JD,
            payload: data
          });
        })
        .catch(function(error) {
          toastr.error(
            "Failed to create the job definition.",
            "Please check the inputs"
          );
        });
    };
  }
};

export const projectSetup = (props, scope) => {
  console.log("Action Project Setup");
  console.log(props);
  let token = loadProcessToken();
  return (dispatch, getState) => {
    console.log("ps", props);
    axios
      .post(`${BASE_URL}/setup_project`, props)
      .then(({ data }) => {
          toastr.success("Project Setup Completed!");
          dispatch({
            type: SETUP_DONE,
            payload: data
          });
      })
      .catch(function(error) {
        toastr.error("Failed to setup the project.", "Please check the inputs");
      });
  };
};

export const deleteJD = (props, scope) => {
  let token = loadProcessToken();
  return (dispatch, getState) => {
    let { _id, arn } = props;
    arn = encodeURIComponent(arn);
    let encodeUrl = `${BASE_URL}/job_definitions?id=${_id}&arn=${arn}`;
    console.log(encodeUrl);
    axios
      .delete(encodeUrl)
      .then(({ data }) => {
        dispatch({
          type: DELETE_JD,
          payload: props._id
        });
        toastr.success("Successfully deleted the job definition");
      })
      .catch(function(error) {
        toastr.error("Failed to delete job definition");
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/job_definitions.js